<template>
  <form action="/logout" method="POST" @submit="logout" novalidate>
    <input type="hidden" name="_token" :value="$options.csrfToken" autocomplete="off" />
    <button :id="buttonId" type="submit" :class="buttonClass" :disabled="isProcessing">
      <slot>Log Out</slot>
    </button>
  </form>
</template>

<script>
import { useResetAllStores } from '@/composables/useResetAllStores';

export default {
  name: 'LogoutForm',
  props: {
    buttonId: {
      type: String,
      default: null,
    },
    buttonClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isProcessing: false,
    };
  },

  setup() {
    return {
      resetAll: useResetAllStores(),
    };
  },
  methods: {
    logout() {
      this.isProcessing = true;
      this.$store.dispatch('resetStore');
      this.resetAll();
    },
  },
};
</script>
